module.exports = "static/assets/bf550f4c2ff75abf5d2d76e87470af92.svg";